import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
  UserRequest,
  AccountService, Configuration, AppConfig, IntroService
} from '../../shared/shared.module';
import {LandingService} from '../../shared/services/landing.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public Config: Configuration;
  @Input() isLogged: boolean;

  footerAccordionStatus = {
    '0': false,
    '1': false,
    '2': false
  };

  constructor(
      private router: Router,
      private landingService: LandingService,
      private accountService: AccountService,
      private introService: IntroService
  ) { }

  user = new UserRequest();

  ngOnInit() {
    this.Config = AppConfig.config;

    this.accountService.isAuthenticated().then(result => {
      this.isLogged = (result.isLoggedIn && !result.isAnonymous);
    });
  }

  checkLogin(pathForRedirect: string) {
    this.scrollTop();
    this.router.navigateByUrl(pathForRedirect);
  }

  accordionFooter(index) {
    this.footerAccordionStatus[index] = !this.footerAccordionStatus[index];
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  openLoginDialog() {
    if (!this.user.Email || !this.user.HPassword) {
      this.landingService.changeUser(this.user);
      this.landingService.toggleLoginDialog(true);
      this.user = new UserRequest();
      return;
    }

    this.landingService.callLogin(this.user);
    this.user = new UserRequest();
  }

  callAuthorization() {
    this.landingService.toggleSignupDialog(false);
    this.landingService.toggleLoginDialog(false);
    this.landingService.toggleAuthorizationDialog(true);
  }

  settingRouter() {
    return (this.isLogged) ? '/main/settings' : '/main/settings/tariff';
  }

  openIntroPopup(e) {
    e.preventDefault();
    if (this.isLogged) {
      this.introService.setPopupStartIntro(true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/landing/footer/footer.component.ts